import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=5fa25be7"
import script from "./MessageAlert.vue?vue&type=script&lang=ts"
export * from "./MessageAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports